import 'bootstrap/dist/css/bootstrap.css';
import { ChangeEvent, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import Spinner from '../../shared/spinner';
import InputMask from 'react-input-mask';
import { format, parse, parseISO, set } from 'date-fns';
import { Usuario } from '../../shared/model/usuario';
import { cpf as cpfValidacao } from 'cpf-cnpj-validator';
import UsuarioService from '../../services/usuarioService';
import CustomAlert from '../../shared/customAlert';
import { Role } from '../../shared/model/role';
import { UUID } from 'crypto';
import { Matriz } from '../../shared/model/matriz';
import { OrigemUsuario } from '../../shared/model/origemUsuario';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import { Alcada } from '../../shared/model/alcada';
import AlcadaService from '../../services/alcadaService';

interface Origem {
  id: number;
  nome: string;
}

function AlcadaInclusaoAlteracao() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);

  const location = useLocation();
  const { id } = location.state || {};
  const { tipo } = useParams();
  const [dtInclusao, setDtInclusao] = useState('');

  const [nomeAlcada, setNomeAlcada] = useState('');
  const [tipoAcesso, setTipoAcesso] = useState('I');
  const [valorAlcada, setValorAlcada] = useState('');
  const [faseAlcada, setFaseAlcada] = useState('');
  const [valorAlcadaInput, setValorAlcadaInput] = useState<number>(0);

  const [aprova, setAprova] = useState(false);
  const [reprova, setReprova] = useState(false);
  const [pendencia, setPendencia] = useState(false);
  const [altera, setAltera] = useState(false);
  
  const [loading, setLoading] = useState(false);

  const alcadaService: AlcadaService = new AlcadaService();

  const listarAlcadaPorId = async () => {
    setLoading(true);
    try {
      const response = await alcadaService.listarAlcadaPorId(id);
      console.log(response.data);

      const json = response.data;
      // setDtInclusao(json.dtInclusao ? format(parseISO(json.dtInclusao), 'dd/MM/yyyy HH:mm:ss') : '');
      setNomeAlcada(json.nomeAlcada);
      setTipoAcesso(json.tipoAcesso);
      if (json.valorAlcada !== undefined && json.valorAlcada !== null) {
          setValorAlcada(json.valorAlcada.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          }));
      } else {
          setValorAlcada('');
      }
      setFaseAlcada(json.faseAlcada);

      setAprova(json.aprova || false);
      setReprova(json.reprova || false);
      setPendencia(json.pendencia || false);
      setAltera(json.altera || false);

      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err.response.data, type: 'error' });
      console.error(err);
    }
  };

  const formatarValorMonetario = (valor: any) => {
    if (!valor) return '0,00';
    const valorComCentavos = valor.padStart(3, '0');
    const reais = valorComCentavos.slice(0, -2);
    const centavos = valorComCentavos.slice(-2);
    return `${parseInt(reais, 10)},${centavos}`;
  };


  const handleInputChange = (e: any) => {
    let value = e.target.value;
    value = value.replace(/\D/g, '');
    if (value) {
      value = (parseFloat(value) / 100).toFixed(2);
      value = value.replace('.', ',');
    }
    setValorAlcadaInput(value);
  };

  const handleValorChange = (e: ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    value = value.replace(/\D/g, "");

    if (value === "") {
      setValorAlcada("");
      return;
    }

    const numero = parseFloat(value) / 100;

    const valorFormatado = numero.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    setValorAlcada(valorFormatado);
  };

  const handleSelecionarTodos = (e: ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setAprova(checked);
    setReprova(checked);
    setPendencia(checked);
    setAltera(checked);
  };

  const todosSelecionados = aprova && reprova && pendencia && altera;

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>): void => {
    // The value from the checkbox (e.g., "1", "2")
    const checkboxNumber: string = event.target.value;
    const isChecked: boolean = event.target.checked;

    setFaseAlcada((prevFaseAlcada: string) => {
      // 1. Convert the current string "1;3;5" into an array of numbers [1, 3, 5]
      const currentNumbers: number[] = prevFaseAlcada
        .split(';')
        .map((numStr) => parseInt(numStr.trim(), 10))
        .filter((num) => !isNaN(num) && num > 0); // Filter out empty strings or invalid numbers

      let newNumbersArray: number[];

      if (isChecked) {
        // Add the new number if it's not already present
        const numToAdd = parseInt(checkboxNumber, 10);
        if (!currentNumbers.includes(numToAdd)) {
          newNumbersArray = [...currentNumbers, numToAdd];
        } else {
          newNumbersArray = currentNumbers; // No change if already present
        }
      } else {
        // Remove the number if it's unchecked
        const numToRemove = parseInt(checkboxNumber, 10);
        newNumbersArray = currentNumbers.filter(
          (num) => num !== numToRemove
        );
      }

      // 2. Sort the numbers numerically
      const sortedNumbers: number[] = newNumbersArray.sort((a, b) => a - b);

      // 3. Convert back to string with semicolon separator
      return sortedNumbers.join(';');
    });
  };


  const handleSubmit = async (event: any) => {
    event.preventDefault();

    // if (!cpfValidacao.isValid(cpf)) return setAlert({ message: 'CPF Inválido', type: 'warning' });
    // let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // if (emailRegex.test(email) === false) return setAlert({ message: 'E-mail Inválido', type: 'warning' });
    // if (senha !== senha2) return setAlert({ message: 'As senhas devem ser iguais!', type: 'warning' });
    // if (senha !== '' && !todosRequisitosAtendidos) { setAlert({ message: 'A senha nova não atende a todos os requisitos.', type: 'warning' }); return; }

    let alcada: Alcada = new Alcada();
    alcada.id = id;
    alcada.nomeAlcada = nomeAlcada;
    alcada.tipoAcesso = tipoAcesso;
    if (valorAlcada) {
        const valorLimpo = valorAlcada.replace(/\./g, '').replace(',', '.');
        alcada.valorAlcada = parseFloat(valorLimpo);
    } else {
        alcada.valorAlcada = 0;
    }
    alcada.faseAlcada = faseAlcada;
    alcada.aprova = aprova;
    alcada.reprova = reprova;
    alcada.pendencia = pendencia;
    alcada.altera = altera;

    try {
      setLoading(true);
      await alcadaService.incluirAlterarAlcada(alcada);

      setLoading(false);
      if (tipo === 'inclusao') {
        setAlert({ message: 'Alçada salva com sucesso!', type: 'success' });
      } else {
        setAlert({ message: 'Alçada alterada com sucesso!', type: 'success' });
      }
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err.response.data, type: 'error' });
      console.error(err);
    }
  };



  useEffect(() => {
    if (tipo === 'alteracao') {
      listarAlcadaPorId();
    }
  }, []);

  function capitalizeFirstLetter(str: string) {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <div className="container">
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => { setAlert(null); if (alert.type === 'success') { window.history.back(); } }} />)}
      {loading ? <Spinner loading={loading} /> : (
        <form onSubmit={handleSubmit}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              {tipo === 'inclusao' ? <h5>Alçadas Esteira &gt; Inclusão</h5> : (
                <h5>Alçadas Esteira &gt; Alteração</h5>
              )}
              <Button id="App-button-cor-principal" onClick={() => window.history.back()}>
                Voltar
              </Button>
            </div>
            <hr className="my-4" />
          </div>

          <div className="row" style={{ marginTop: '20px' }}>
            {tipo === 'alteracao' ? (
              <>
                <div className="col-md-1">
                  <label>Código</label>
                  <input readOnly type="text" className="form-control" value={id} style={{ backgroundColor: 'LightGrey' }} />
                </div>
              </>
            ) : null}
            <div className="col-md-3">
              <label>Nome da Alçada <span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={nomeAlcada} onChange={(e) => setNomeAlcada(e.target.value)} />
            </div>
            <div className="col-md-2">
              <label>Tipo de Acesso <span style={{ color: "red" }}>*</span></label>
              <select className="form-select" value={tipoAcesso}
                          onChange={(e) => {setTipoAcesso(e.target.value);}}
                        >
                          <option selected value="I">INTERNO</option>
                          <option value="E">EXTERNO</option>
                        </select>
            </div>
            <div className="col-md-4">
              <label>Valor Alçada <span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={valorAlcada} onChange={handleValorChange} placeholder="0,00" />
            </div>

            <div className="row mt-3">
            
            {/* Bloco da Esquerda: Permissões (Ocupa 4 colunas) */}
            <div className="col-md-4">
              <label>Permissões de fase da Alçada</label>
              <div style={{ border: '1px solid #ced4da', borderRadius: '0.25rem', padding: '10px', backgroundColor: '#fff' }}>

                <div className="form-check mb-2">
                  <input className="form-check-input" type="checkbox" id="chkTodos"
                    checked={todosSelecionados} onChange={handleSelecionarTodos} />
                  <label className="form-check-label fw-bold" htmlFor="chkTodos">Selecionar Todos</label>
                </div>
                
                <hr style={{ margin: '5px 0 10px 0' }} />

                <div className="d-flex flex-wrap gap-2">
                  <div className="form-check me-2">
                    <input className="form-check-input" type="checkbox" id="chkAprovar"
                      checked={aprova} onChange={(e) => setAprova(e.target.checked)} />
                    <label className="form-check-label" htmlFor="chkAprovar">Aprovar</label>
                  </div>
                  <div className="form-check me-2">
                    <input className="form-check-input" type="checkbox" id="chkReprovar"
                      checked={reprova} onChange={(e) => setReprova(e.target.checked)} />
                    <label className="form-check-label" htmlFor="chkReprovar">Reprovar</label>
                  </div>
                  <div className="form-check me-2">
                    <input className="form-check-input" type="checkbox" id="chkPendenciar"
                      checked={pendencia} onChange={(e) => setPendencia(e.target.checked)} />
                    <label className="form-check-label" htmlFor="chkPendenciar">Pendenciar</label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="chkAlterar"
                      checked={altera} onChange={(e) => setAltera(e.target.checked)} />
                    <label className="form-check-label" htmlFor="chkAlterar">Alterar dados</label>
                  </div>
                </div>
              </div>
            </div>

            {/* Bloco da Direita: Fase Esteira (Ocupa 8 colunas) */}
            <div className='col-md-8'>
              <label>Fase Esteira</label>
              {/* Adicionei uma margem top pequena ou alinhamento para ficar visualmente parelho com o box ao lado se necessário */}
              <div className="d-flex flex-wrap gap-3 mt-2"> 
                {[...Array(10)].map((_, index) => {
                  const displayValue: string = String(index + 1).padStart(2, '0');
                  const storedValue: string = String(index + 1);

                  return (
                    <div key={index} className="form-check me-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`checkbox-${displayValue}`}
                        name={`faseEsteira`}
                        value={storedValue}
                        checked={
                          faseAlcada
                            .split(';')
                            .map((numStr) => numStr.trim())
                            .includes(storedValue)
                        }
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label" htmlFor={`checkbox-${displayValue}`}>
                        {displayValue}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          </div>

          {tipo === 'alteracao' ? (
            <div className="row">
            </div>
          ) : (
            <div className="row">
            </div>
          )}

          <div>
            <hr className="my-4" />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <button className="w-40 btn btn-primary btn-lg btn btn-success" type="submit">{tipo !== 'inclusao' ? 'Alterar Alçada' : 'Salvar Alçada'}</button>
              </div>
            </div>
          </div>
        </form>
      )
      }
    </div >
  );
}

export default AlcadaInclusaoAlteracao;